import { IOperationHandler } from '@ms/items-view/lib/private/store/actions/implementOperation';
import { spItemSetKeyFacet, spFolderItemSetKeyFacet } from '../../../dataSource/Keys';
import { getItemsOperation } from '@ms/items-view/lib/private/operations/getItemsOperation';
import {
  createSingleItemOperationHandler,
  ISingleOperationPayload,
  IOperationHandlerThunkAction,
  registerOperationHandler
} from '@ms/items-view/lib/private/addons/registerOperationHandler';
import { IItemCacheDispatch } from '@ms/items-view/lib/private/store/actions/ItemCacheActions';
import { ItemResolver } from '@ms/items-view/lib/private/models/items/ItemResolver';
import { preferredKeyFacetFacet } from '@ms/items-view/lib/private/facets/OperationFacets';
import {
  createAddon,
  IAddon
} from '@ms/items-view/lib/private/addons/registerOperationHandler';

const spItemSetGetItemsOperationHandler:
  IOperationHandler<typeof spItemSetKeyFacet.type, typeof getItemsOperation.type> =
  createSingleItemOperationHandler({
    maxParallelOperationCount: 16
  })(getSPItemSet);

function getSPItemSet(
  payload: ISingleOperationPayload<typeof spItemSetKeyFacet.type, typeof getItemsOperation.type>
): IOperationHandlerThunkAction {
  const {
    itemKey
  } = payload;

  const {
    parentItemKey: {
      webAbsoluteUrl,
      listFullUrl,
      rootFolder
    }
  } = spItemSetKeyFacet.deserialize(itemKey);

  return async (dispatch: IItemCacheDispatch) => {
    const itemResolver = new ItemResolver();

    itemResolver.mapKeys({
      mappings: {
        [spFolderItemSetKeyFacet.serialize({
          webAbsoluteUrl,
          listFullUrl,
          rootFolder: rootFolder || ''
        })]: itemKey
      }
    });

    itemResolver.resolveItems({
      items: {
        [itemKey]: {
          ...spFolderItemSetKeyFacet.pack({
            webAbsoluteUrl,
            listFullUrl,
            rootFolder: rootFolder || ''
          }),
          ...preferredKeyFacetFacet.pack(spFolderItemSetKeyFacet)
        }
      }
    });

    dispatch(itemResolver.execute());
  };
}

export const getSPItemSetAddon: IAddon = createAddon(() => {
  return async (dispatch: IItemCacheDispatch) => {
    dispatch(registerOperationHandler(spItemSetKeyFacet, getItemsOperation)(
      spItemSetGetItemsOperationHandler
    ));
  };
});